export const attachmentsCategoriesName = {
  attachments: 'Attachments',
  quotes: 'Quotes',
  contracts: 'Contracts',
  networkDiagram: 'Diagrams',
};
